// extracted by mini-css-extract-plugin
module.exports = {"Container":"LogScreen_Container__3MrW8","LogBackground":"LogScreen_LogBackground__13_a8","Header":"LogScreen_Header__1mWlC","Content":"LogScreen_Content__3VMWt"};